import React from "react";
import {useState, useEffect, useRef} from "react";
import I18n from 'i18n.js.erb'
import { DESKTOP_WIDTH, titleize } from "../../utils/utils";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'


function useComponentVisible(initialIsVisible) {
  const [isComponentVisible, setIsComponentVisible] = useState(
    initialIsVisible
  );
  const ref = useRef(null);

  // const handleHideDropdown = (event: KeyboardEvent) => {
  const handleHideDropdown = (event) => {
    if (event.key === "Escape") {
      setIsComponentVisible(false);
    }
  };

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleHideDropdown, true);
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("keydown", handleHideDropdown, true);
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  return {ref, isComponentVisible, setIsComponentVisible};
}


const AddBlueprintImageToDataStructureFlowMenuSealed = ({
     logged_in_user,
     onMultipleSelectHandler,
     selectAll,
     alertPopupHandler,
     viewOffersHandler,
     filterVersions,
     setVersionFilter,
     versions,
     atLeastOnSelectedCard,
     globalQuantity,
     onChangeGlobalQuantity,
     isEnableAction,
     setEnabledActions,
     disable_marketplace
   }) => {

  const {
    ref,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);


  //Funzione jquery che mi permette di gestire la posizione del
  // bottone che apre il menù delle azioni su mobile e tablet.
  $(window).on("scroll", function () {

    //se il dispositivo è uno smartphone o un tablet e la pagina
    // ha scrollato verso l'alto di 259 px allora blocco
    // la posizione del bottone

    if ($(window).innerWidth() < DESKTOP_WIDTH) {
      if ($(window).scrollTop() >= 259) {
        $("#cards-actions-menu").css("top", "72px");
        $("#action-menu-btn-mobile").css("position", "fixed");
        $("#cards-actions-menu").css("position", "fixed");
      } else {
        $("#cards-actions-menu").css("position", "");
        }
    }

    // sono su desktop e blocco quando ho scrollato di 152px verso l'alto
    if ($(window).innerWidth() > DESKTOP_WIDTH) {
      if ($(window).scrollTop() >= 1) {
        setIsComponentVisible(false)
      }
    }

  });


  return (
    <React.Fragment>
      <div id="action-menu-btn-mobile"
           className="button-show-all-sub-expansion-on-mobile rounded-right ml-negative-2px show-on-mobile">
        <button type="button" className={`btn ${filterVersions.length > 0 ? 'icon--bg-active' : 'bg-side-button'}`}
                onClick={(e) => setEnabledActions(true)}>
          <i id="action-menu-icon"
             className={`fas fa-pencil-alt enable-filters-expansions-icon ${filterVersions.length > 0 ? 'icon--color-active' : 'icon--color-standard'}`}/>
        </button>
      </div>


      {/*action menu dispositivi desktop*/}
      <div id="product-actions-menu-desktop"
           className={`container rounded show-on-desktop bg-white position-fixed cont-bl-images ${isEnableAction && window.innerWidth >= DESKTOP_WIDTH ? 'd-flex' : 'd-none'} bg-light-gray-imp expansion--desktop--border-box shadow`}
      >

        <div className="w-100 minH-160px" style={{zIndex: 10}}>

          <div className="row mt-0 mb-0">
            <div className="col-12 mt-10px d-block text-center">
              <button
                id="select_unselect_all"
                className="btn-standard bg-dark text-light btn-standard-resized p-2"
                type="button"
                onClick={onMultipleSelectHandler}>
                <i className={`${selectAll ? 'fas fa-hand-pointer' : 'far fa-hand-pointer'} fa-lg`} />
              </button>
              <p className="text--size-small text-line-height-1 mt-1">{selectAll ? I18n.t('js.common.button.selectAll') : I18n.t('js.common.button.unSelectAll')}</p>
            </div>
          </div>

          {
            !disable_marketplace &&
              <React.Fragment>
                <div className="row mt-0 mb-0">
                  <div className="col-12 mt-10px d-block text-center">

                    <button type="button"
                            id="offers"
                            className="btn-standard bg-dark text-light btn-standard-resized p-2"
                            onClick={viewOffersHandler}>
                      <i className="fa fa-eye icon-in-btn-size fa-lg"/>
                    </button>
                    <p className="text--size-small text--white-space-no-wrap text-line-height-1 mt-1 mb-0">{I18n.t('js.common.button.viewOffersShort')}</p>
                  </div>
                </div>

                <div className="row mt-2 mb-0">
                  <div className="col-12 mt-10px d-block text-center">
                    <button type="button"
                            id="add_to"
                            className="btn-standard bg-dark text-light btn-standard-resized p-2"
                            disabled={!atLeastOnSelectedCard}
                            onClick={() => setIsComponentVisible(true)}>
                      <i className="fa fa-plus-circle fa-lg"/>
                    </button>
                    <p className="text--size-small text--white-space-no-wrap text-line-height-1 mt-1">{I18n.t('js.common.button.addTo')}</p>
                  </div>
                </div>
              </React.Fragment>
          }


            <div className="row">
              <div className="col-12 mt-10px text-centerd-block">

                  <div className="d-flex justify-content-start align-items-center">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-top`}>
                          <p>{I18n.t('js.common.quantityTooltipContent')}</p>
                        </Tooltip>
                      }
                    >
                      <div>
                    <input
                      className="form-control"
                      disabled={!atLeastOnSelectedCard}
                      value={globalQuantity}
                      name="selected_cards_quantity"
                      type="number"
                      onChange={(e) => onChangeGlobalQuantity(e.target.value)}
                    />
                      </div>
                    </OverlayTrigger>
                  </div>

                  <p
                    className={`${!atLeastOnSelectedCard ? 'text--disabled' : 'text-dark'} text--size-small text-center text-line-height-1 mt-1`}>
                    {I18n.t('js.indexCardPage.inputCardQuantityShort')}
                  </p>

              </div>
            </div>


          {
            versions.length > 1 && (
              versions.map((version) => {
                return (
                  <div className="row mt-20px">
                  <div className="col-6 d-md-flex align-items-md-center mt-8px mb-10px"
                       key={version}>
                    <p className="noselect mb-0 text-center text-md-left text-weight-500 text--size-normal">
                      {titleize(version)}
                    </p>
                    <input
                      type="checkbox"
                      className="ml-10px-imp mt-0"
                      id={version}
                      onChange={(e) => setVersionFilter(e)}
                    />
                  </div>
                  </div>
                );
              })
            )}
        </div>
      </div>

      {
        !disable_marketplace &&
          <div ref={ref} className={`size-h-3px-w-3px  ${!isComponentVisible && 'd-none'}`}>
            <div className="bubble position-fixed shadow p-2">
              <p className="text-weight-700 text-night-blue text-center text-space">
                {I18n.t('js.indexSealedPage.addProductTo')}
              </p>
              <div className="border-bottom-dark d-flex justify-content-center pt-20px pb-10px pl-3 pr-3 cursor-pointer"
                   id="add_to_wishlist"
                   onClick={() => alertPopupHandler("wishList")}>
                <i className="fas fa-heart mr-3 w-5 col-2 p-0 mt-4px"></i>
                <p className="col-10 text-left p-0">{I18n.t('js.common.button.addInWishlistShort')}</p>
              </div>
              <div className="d-flex justify-content-center pt-10px pb-10px pl-3 pr-3 cursor-pointer"
                   id="add_to_my_collection"
                   onClick={() => alertPopupHandler("myCollection")}>
                <i className="fas fa-gem mr-3 w-5 col-2 p-0 mt-4px"/>
                <p className="col-10 text-left p-0">{I18n.t('js.common.button.addInMyCollectionShort')}</p>
              </div>
              <div className="pointer"></div>
            </div>
          </div>
      }


      {/*action menu dispositivi mobile*/}
      <div id="cards-actions-menu"
           className={`${isEnableAction && window.innerWidth < DESKTOP_WIDTH ? 'd-flex' : 'd-none'} container shadow  form-group font-small w-100 show-on-mobile-d-block expansion__filter--mobile-position col-12 text--size-normal bg-light-gray right-0`}>

        <div className={`${logged_in_user ? 'minH-290px' : 'minH-175px'} w-100  mb-20px`}>

          <div className="col-12 text-right">
            <button type="button" className="btn p-0 mt-8px mr-8px"
                    onClick={(e) => setEnabledActions(false)}>
              <i id="close-action-menu-icon" className="fas fa-times icon-close--size"/>
            </button>
          </div>

          <div className="col-12">
            <div className="row ">
              <div className="col-12 mt-10px">

                <div className="row">
                  <div className="col-6">
                    <button
                      className="btn-standard bg-dark text-light mt-1 pt-1 pr-5 btn-standard-resized w-100 p-5px-imp"
                      type="button"
                      onClick={onMultipleSelectHandler}>
                      {selectAll ? I18n.t('js.common.button.selectAll') : I18n.t('js.common.button.unSelectAll')}
                    </button>
                  </div>
                  <div className="col-6">
                    <div className="d-flex justify-content-center mb-3" style={{zIndex: 10}}>
                      <button type="button"
                              className="btn btn-standard bg-dark text-light mt-1 pt-1 pr-5 btn-standard-resized w-100 p-5px-imp noselect"
                              onClick={viewOffersHandler}>
                        <i className="fa fa-eye icon-in-btn-size mr-8px"/>
                        {I18n.t('js.common.button.viewOffers')}
                      </button>
                    </div>
                  </div>
                </div>

                {
                  !disable_marketplace &&
                  <React.Fragment>
                    <div className="row">
                      <div className="col-6">
                        <button type="button"
                                className="btn btn-standard bg-dark text-light mt-1 pb-1 pr-5 btn-standard-resized w-100 p-5px-imp noselect minH-40px-imp text-on-new-line"
                                disabled={!atLeastOnSelectedCard}
                                style={{color: '#e8dada', backgroundColor: '#24272c'}}
                                onClick={() => alertPopupHandler("wishList")}>
                          <i className="fa fa-plus-circle icon-in-btn-size mr-8px"/>
                          {I18n.t('js.common.button.addInWishlist')}
                        </button>
                      </div>
                    </div>

                    <div className="row mt-2 mt-md-3 mb-2">
                      <div className="col-6">
                        <button type="button"
                                className="btn btn-standard bg-dark text-light mt-1 pt-1 pr-5 btn-standard-resized w-100 p-5px-imp noselect minH-40px-imp text-on-new-line"
                                disabled={!atLeastOnSelectedCard}
                                style={{color: 'black', backgroundColor: 'white'}}
                                onClick={() => alertPopupHandler("myCollection")}>
                          <i className="fa fa-plus-circle icon-in-btn-size mr-8px"/>
                          {I18n.t('js.common.button.addInMyCollection')}
                        </button>
                      </div>

                      <div className="col-6">
                        <p
                          className={`${!atLeastOnSelectedCard ? 'text--disabled' : 'text-dark'} text-weight-500 text--size-normal text-center mb-0`}>
                          {I18n.t('js.indexCardPage.inputCardQuantity')}
                        </p>

                        <div className="d-flex justify-content-start align-items-center">
                          <input
                            className="form-control"
                            disabled={!atLeastOnSelectedCard}
                            value={globalQuantity}
                            name="selected_cards_quantity"
                            type="number"
                            onChange={(e) => onChangeGlobalQuantity(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                }

                <div className="row mt-20px">
                  {
                    versions.length > 1 && (
                      versions.map((version) => {
                        return (
                          <div className="col-3 d-md-flex align-items-md-center"
                               key={version}>
                            <p className="noselect mb-0 text-center text-md-left text-weight-500">
                              {titleize(version)}
                            </p>
                            <input
                              type="checkbox"
                              className="ml-20px-imp filter-checkbox--size"
                              id={version}
                              onChange={(e) => setVersionFilter(e)}
                            />
                          </div>
                        );
                      })
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddBlueprintImageToDataStructureFlowMenuSealed;